package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.RoomRawQuery
import androidx.room3.coroutines.createFlow
import androidx.room3.paging.PagingSourceDaoReturnTypeConverter
import androidx.room3.util.appendPlaceholders
import androidx.room3.util.getColumnIndex
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import com.xtream.data_kmp.WatchedIntermediateSeriesStream
import com.xtream.data_kmp.WatchedSeriesStreams
import com.xtream.data_kmp.db.StringListConverter
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.TrendingTvShow
import kotlin.Boolean
import kotlin.Double
import kotlin.Float
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlin.text.StringBuilder
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class SeriesStreamsDao_Impl(
  __db: RoomDatabase,
) : SeriesStreamsDao() {
  private val __db: RoomDatabase

  private val __insertAdapterOfSeriesStream: EntityInsertAdapter<SeriesStream>

  private val __insertAdapterOfTrendingTvShow: EntityInsertAdapter<TrendingTvShow>

  private val __deleteAdapterOfSeriesStream: EntityDeleteOrUpdateAdapter<SeriesStream>

  private val __pagingSourceDaoReturnTypeConverter: PagingSourceDaoReturnTypeConverter =
      PagingSourceDaoReturnTypeConverter()
  init {
    this.__db = __db
    this.__insertAdapterOfSeriesStream = object : EntityInsertAdapter<SeriesStream>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `seriesStreamsTable` (`streamId`,`num`,`name`,`plot`,`streamIcon`,`cast`,`director`,`genre`,`releaseDate`,`lastModified`,`rating`,`ratingFiveBased`,`backdropPath`,`youtubeTrailer`,`episodeRunTime`,`categoryId`,`streamType`) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: SeriesStream) {
        statement.bindLong(1, entity.streamId.toLong())
        val _tmpNum: Int? = entity.num
        if (_tmpNum == null) {
          statement.bindNull(2)
        } else {
          statement.bindLong(2, _tmpNum.toLong())
        }
        statement.bindText(3, entity.name)
        val _tmpPlot: String? = entity.plot
        if (_tmpPlot == null) {
          statement.bindNull(4)
        } else {
          statement.bindText(4, _tmpPlot)
        }
        val _tmpStreamIcon: String? = entity.streamIcon
        if (_tmpStreamIcon == null) {
          statement.bindNull(5)
        } else {
          statement.bindText(5, _tmpStreamIcon)
        }
        val _tmpCast: String? = entity.cast
        if (_tmpCast == null) {
          statement.bindNull(6)
        } else {
          statement.bindText(6, _tmpCast)
        }
        val _tmpDirector: String? = entity.director
        if (_tmpDirector == null) {
          statement.bindNull(7)
        } else {
          statement.bindText(7, _tmpDirector)
        }
        val _tmpGenre: String? = entity.genre
        if (_tmpGenre == null) {
          statement.bindNull(8)
        } else {
          statement.bindText(8, _tmpGenre)
        }
        val _tmpReleaseDate: String? = entity.releaseDate
        if (_tmpReleaseDate == null) {
          statement.bindNull(9)
        } else {
          statement.bindText(9, _tmpReleaseDate)
        }
        val _tmpLastModified: String? = entity.lastModified
        if (_tmpLastModified == null) {
          statement.bindNull(10)
        } else {
          statement.bindText(10, _tmpLastModified)
        }
        val _tmpRating: String? = entity.rating
        if (_tmpRating == null) {
          statement.bindNull(11)
        } else {
          statement.bindText(11, _tmpRating)
        }
        val _tmpRatingFiveBased: String? = entity.ratingFiveBased
        if (_tmpRatingFiveBased == null) {
          statement.bindNull(12)
        } else {
          statement.bindText(12, _tmpRatingFiveBased)
        }
        val _tmpBackdropPath: List<String?>? = entity.backdropPath
        val _tmp: String? = StringListConverter.listToString(_tmpBackdropPath)
        if (_tmp == null) {
          statement.bindNull(13)
        } else {
          statement.bindText(13, _tmp)
        }
        val _tmpYoutubeTrailer: String? = entity.youtubeTrailer
        if (_tmpYoutubeTrailer == null) {
          statement.bindNull(14)
        } else {
          statement.bindText(14, _tmpYoutubeTrailer)
        }
        val _tmpEpisodeRunTime: String? = entity.episodeRunTime
        if (_tmpEpisodeRunTime == null) {
          statement.bindNull(15)
        } else {
          statement.bindText(15, _tmpEpisodeRunTime)
        }
        val _tmpCategoryId: Int? = entity.categoryId
        if (_tmpCategoryId == null) {
          statement.bindNull(16)
        } else {
          statement.bindLong(16, _tmpCategoryId.toLong())
        }
        statement.bindText(17, entity.streamType)
      }
    }
    this.__insertAdapterOfTrendingTvShow = object : EntityInsertAdapter<TrendingTvShow>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `TrendingTvShows` (`adult`,`backdrop`,`id`,`name`,`overview`,`streamIcon`,`popularity`,`releaseDate`,`voteAverage`,`streamId`) VALUES (?,?,?,?,?,?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: TrendingTvShow) {
        val _tmp: Int = if (entity.adult) 1 else 0
        statement.bindLong(1, _tmp.toLong())
        val _tmpBackdrop: String? = entity.backdrop
        if (_tmpBackdrop == null) {
          statement.bindNull(2)
        } else {
          statement.bindText(2, _tmpBackdrop)
        }
        statement.bindLong(3, entity.id.toLong())
        statement.bindText(4, entity.name)
        statement.bindText(5, entity.overview)
        val _tmpStreamIcon: String? = entity.streamIcon
        if (_tmpStreamIcon == null) {
          statement.bindNull(6)
        } else {
          statement.bindText(6, _tmpStreamIcon)
        }
        val _tmpPopularity: Float? = entity.popularity
        if (_tmpPopularity == null) {
          statement.bindNull(7)
        } else {
          statement.bindDouble(7, _tmpPopularity.toDouble())
        }
        statement.bindText(8, entity.releaseDate)
        val _tmpVoteAverage: Double? = entity.voteAverage
        if (_tmpVoteAverage == null) {
          statement.bindNull(9)
        } else {
          statement.bindDouble(9, _tmpVoteAverage)
        }
        statement.bindLong(10, entity.streamId.toLong())
      }
    }
    this.__deleteAdapterOfSeriesStream = object : EntityDeleteOrUpdateAdapter<SeriesStream>() {
      protected override fun createQuery(): String = "DELETE FROM `seriesStreamsTable` WHERE `streamId` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: SeriesStream) {
        statement.bindLong(1, entity.streamId.toLong())
      }
    }
  }

  public override suspend fun insert(item: SeriesStream): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfSeriesStream.insert(_connection, item)
  }

  public override suspend fun insert(items: List<SeriesStream>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfSeriesStream.insert(_connection, items)
  }

  public override suspend fun insertTrending(newList: List<TrendingTvShow>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfTrendingTvShow.insert(_connection, newList)
  }

  public override suspend fun delete(item: SeriesStream): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfSeriesStream.handle(_connection, item)
  }

  public override suspend fun delete(items: List<SeriesStream>): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfSeriesStream.handleMultiple(_connection, items)
  }

  public override fun allAsFlow(): Flow<List<SeriesStream>> {
    val _sql: String = "SELECT * FROM seriesStreamsTable ORDER BY lastModified DESC"
    return createFlow(__db, false, arrayOf("seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsFlow(
    categoryId: Int?,
    nameQuery: String?,
    limit: Int?,
    offset: Int?,
  ): Flow<List<SeriesStream>> {
    val _sql: String = "SELECT * FROM seriesStreamsTable WHERE (? IS NULL OR categoryId = ?) AND (? IS NULL OR name LIKE '%' || ? || '%') ORDER BY lastModified DESC LIMIT ? OFFSET ?"
    return createFlow(__db, false, arrayOf("seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 3
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 4
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 5
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        _argIndex = 6
        if (offset == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, offset.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsFlow(categoryId: Int?, nameQuery: String?): Flow<List<SeriesStream>> {
    val _sql: String = "SELECT * FROM seriesStreamsTable WHERE (? IS NULL OR categoryId = ?) AND (? IS NULL OR name LIKE '%' || ? || '%') ORDER BY lastModified DESC"
    return createFlow(__db, false, arrayOf("seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 3
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 4
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsPagingSource(categoryId: Int?, nameQuery: String?): PagingSource<Int, SeriesStream> {
    val _sql: String = "SELECT * FROM seriesStreamsTable WHERE (? IS NULL OR categoryId = ?) AND (? IS NULL OR name LIKE '%' || ? || '%') ORDER BY lastModified DESC"
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      var _argIndex: Int = 1
      if (categoryId == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindLong(_argIndex, categoryId.toLong())
      }
      _argIndex = 2
      if (categoryId == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindLong(_argIndex, categoryId.toLong())
      }
      _argIndex = 3
      if (nameQuery == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindText(_argIndex, nameQuery)
      }
      _argIndex = 4
      if (nameQuery == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindText(_argIndex, nameQuery)
      }
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("seriesStreamsTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<SeriesStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
          val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
          val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
          val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
          val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
          val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
          val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _result: MutableList<SeriesStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: SeriesStream
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpPlot: String?
            if (_stmt.isNull(_columnIndexOfPlot)) {
              _tmpPlot = null
            } else {
              _tmpPlot = _stmt.getText(_columnIndexOfPlot)
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpCast: String?
            if (_stmt.isNull(_columnIndexOfCast)) {
              _tmpCast = null
            } else {
              _tmpCast = _stmt.getText(_columnIndexOfCast)
            }
            val _tmpDirector: String?
            if (_stmt.isNull(_columnIndexOfDirector)) {
              _tmpDirector = null
            } else {
              _tmpDirector = _stmt.getText(_columnIndexOfDirector)
            }
            val _tmpGenre: String?
            if (_stmt.isNull(_columnIndexOfGenre)) {
              _tmpGenre = null
            } else {
              _tmpGenre = _stmt.getText(_columnIndexOfGenre)
            }
            val _tmpReleaseDate: String?
            if (_stmt.isNull(_columnIndexOfReleaseDate)) {
              _tmpReleaseDate = null
            } else {
              _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
            }
            val _tmpLastModified: String?
            if (_stmt.isNull(_columnIndexOfLastModified)) {
              _tmpLastModified = null
            } else {
              _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
            }
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            val _tmpBackdropPath: List<String?>?
            val _tmp: String?
            if (_stmt.isNull(_columnIndexOfBackdropPath)) {
              _tmp = null
            } else {
              _tmp = _stmt.getText(_columnIndexOfBackdropPath)
            }
            _tmpBackdropPath = StringListConverter.stringToList(_tmp)
            val _tmpYoutubeTrailer: String?
            if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
              _tmpYoutubeTrailer = null
            } else {
              _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
            }
            val _tmpEpisodeRunTime: String?
            if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
              _tmpEpisodeRunTime = null
            } else {
              _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
            }
            val _tmpCategoryId: Int?
            if (_stmt.isNull(_columnIndexOfCategoryId)) {
              _tmpCategoryId = null
            } else {
              _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            }
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun allAsPagingSource(categoryIds: List<Int>?, nameQuery: String?): PagingSource<Int, SeriesStream> {
    val _stringBuilder: StringBuilder = StringBuilder()
    _stringBuilder.append("SELECT * FROM seriesStreamsTable WHERE (")
    val _inputSize: Int = if (categoryIds == null) 1 else categoryIds.size
    appendPlaceholders(_stringBuilder, _inputSize)
    _stringBuilder.append(" IS NULL OR categoryId IN (")
    val _inputSize_1: Int = if (categoryIds == null) 1 else categoryIds.size
    appendPlaceholders(_stringBuilder, _inputSize_1)
    _stringBuilder.append(")) AND (")
    _stringBuilder.append("?")
    _stringBuilder.append(" IS NULL OR name LIKE '%' || ")
    _stringBuilder.append("?")
    _stringBuilder.append(" || '%') ORDER BY lastModified DESC")
    val _sql: String = _stringBuilder.toString()
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      var _argIndex: Int = 1
      if (categoryIds == null) {
        _stmt.bindNull(_argIndex)
      } else {
        for (_item: Int in categoryIds) {
          _stmt.bindLong(_argIndex, _item.toLong())
          _argIndex++
        }
      }
      _argIndex = 1 + _inputSize
      if (categoryIds == null) {
        _stmt.bindNull(_argIndex)
      } else {
        for (_item_1: Int in categoryIds) {
          _stmt.bindLong(_argIndex, _item_1.toLong())
          _argIndex++
        }
      }
      _argIndex = 1 + _inputSize + _inputSize
      if (nameQuery == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindText(_argIndex, nameQuery)
      }
      _argIndex = 2 + _inputSize + _inputSize
      if (nameQuery == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindText(_argIndex, nameQuery)
      }
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("seriesStreamsTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<SeriesStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
          val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
          val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
          val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
          val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
          val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
          val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _result: MutableList<SeriesStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: SeriesStream
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpPlot: String?
            if (_stmt.isNull(_columnIndexOfPlot)) {
              _tmpPlot = null
            } else {
              _tmpPlot = _stmt.getText(_columnIndexOfPlot)
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpCast: String?
            if (_stmt.isNull(_columnIndexOfCast)) {
              _tmpCast = null
            } else {
              _tmpCast = _stmt.getText(_columnIndexOfCast)
            }
            val _tmpDirector: String?
            if (_stmt.isNull(_columnIndexOfDirector)) {
              _tmpDirector = null
            } else {
              _tmpDirector = _stmt.getText(_columnIndexOfDirector)
            }
            val _tmpGenre: String?
            if (_stmt.isNull(_columnIndexOfGenre)) {
              _tmpGenre = null
            } else {
              _tmpGenre = _stmt.getText(_columnIndexOfGenre)
            }
            val _tmpReleaseDate: String?
            if (_stmt.isNull(_columnIndexOfReleaseDate)) {
              _tmpReleaseDate = null
            } else {
              _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
            }
            val _tmpLastModified: String?
            if (_stmt.isNull(_columnIndexOfLastModified)) {
              _tmpLastModified = null
            } else {
              _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
            }
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            val _tmpBackdropPath: List<String?>?
            val _tmp: String?
            if (_stmt.isNull(_columnIndexOfBackdropPath)) {
              _tmp = null
            } else {
              _tmp = _stmt.getText(_columnIndexOfBackdropPath)
            }
            _tmpBackdropPath = StringListConverter.stringToList(_tmp)
            val _tmpYoutubeTrailer: String?
            if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
              _tmpYoutubeTrailer = null
            } else {
              _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
            }
            val _tmpEpisodeRunTime: String?
            if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
              _tmpEpisodeRunTime = null
            } else {
              _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
            }
            val _tmpCategoryId: Int?
            if (_stmt.isNull(_columnIndexOfCategoryId)) {
              _tmpCategoryId = null
            } else {
              _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            }
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun allAsPagingSource(): PagingSource<Int, SeriesStream> {
    val _sql: String = "SELECT * FROM seriesStreamsTable ORDER BY lastModified DESC"
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("seriesStreamsTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<SeriesStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
          val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
          val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
          val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
          val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
          val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
          val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _result: MutableList<SeriesStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: SeriesStream
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpPlot: String?
            if (_stmt.isNull(_columnIndexOfPlot)) {
              _tmpPlot = null
            } else {
              _tmpPlot = _stmt.getText(_columnIndexOfPlot)
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpCast: String?
            if (_stmt.isNull(_columnIndexOfCast)) {
              _tmpCast = null
            } else {
              _tmpCast = _stmt.getText(_columnIndexOfCast)
            }
            val _tmpDirector: String?
            if (_stmt.isNull(_columnIndexOfDirector)) {
              _tmpDirector = null
            } else {
              _tmpDirector = _stmt.getText(_columnIndexOfDirector)
            }
            val _tmpGenre: String?
            if (_stmt.isNull(_columnIndexOfGenre)) {
              _tmpGenre = null
            } else {
              _tmpGenre = _stmt.getText(_columnIndexOfGenre)
            }
            val _tmpReleaseDate: String?
            if (_stmt.isNull(_columnIndexOfReleaseDate)) {
              _tmpReleaseDate = null
            } else {
              _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
            }
            val _tmpLastModified: String?
            if (_stmt.isNull(_columnIndexOfLastModified)) {
              _tmpLastModified = null
            } else {
              _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
            }
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            val _tmpBackdropPath: List<String?>?
            val _tmp: String?
            if (_stmt.isNull(_columnIndexOfBackdropPath)) {
              _tmp = null
            } else {
              _tmp = _stmt.getText(_columnIndexOfBackdropPath)
            }
            _tmpBackdropPath = StringListConverter.stringToList(_tmp)
            val _tmpYoutubeTrailer: String?
            if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
              _tmpYoutubeTrailer = null
            } else {
              _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
            }
            val _tmpEpisodeRunTime: String?
            if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
              _tmpEpisodeRunTime = null
            } else {
              _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
            }
            val _tmpCategoryId: Int?
            if (_stmt.isNull(_columnIndexOfCategoryId)) {
              _tmpCategoryId = null
            } else {
              _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            }
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override suspend fun hasEntity(id: Int): Boolean {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM seriesStreamsTable WHERE streamId = ?)"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, id.toLong())
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun hasEntityAsFlow(id: Int?): Flow<Boolean> {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM seriesStreamsTable WHERE streamId = ?)"
    return createFlow(__db, false, arrayOf("seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (id == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, id.toLong())
        }
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getSize(): Long? {
    val _sql: String = "SELECT COUNT(*) FROM seriesStreamsTable "
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getSize(categoryId: Int?): Long? {
    val _sql: String = "SELECT COUNT(*) FROM seriesStreamsTable  WHERE (? IS NULL OR categoryId = ?)"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun recentlyAdded(): List<SeriesStream> {
    val _sql: String = "SELECT * FROM seriesStreamsTable ORDER BY lastModified DESC LIMIT 10"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun recentlyAddedFlow(limit: Int): Flow<List<SeriesStream>> {
    val _sql: String = "SELECT * FROM seriesStreamsTable ORDER BY lastModified DESC LIMIT ?"
    return createFlow(__db, false, arrayOf("seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, limit.toLong())
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getRecentlyAddedSize(): Flow<Long> {
    val _sql: String = "SELECT COUNT(*) FROM seriesStreamsTable ORDER BY lastModified DESC LIMIT 10"
    return createFlow(__db, false, arrayOf("seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long
        if (_stmt.step()) {
          val _tmp: Long
          _tmp = _stmt.getLong(0)
          _result = _tmp
        } else {
          _result = 0L
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getRecentlyAdded(limit: Int): PagingSource<Int, SeriesStream> {
    val _sql: String = """
        |
        |        SELECT * FROM seriesStreamsTable
        |        ORDER BY lastModified DESC
        |        LIMIT ?
        |    
        """.trimMargin()
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      var _argIndex: Int = 1
      _stmt.bindLong(_argIndex, limit.toLong())
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("seriesStreamsTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<SeriesStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
          val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
          val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
          val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
          val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
          val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
          val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _result: MutableList<SeriesStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: SeriesStream
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpPlot: String?
            if (_stmt.isNull(_columnIndexOfPlot)) {
              _tmpPlot = null
            } else {
              _tmpPlot = _stmt.getText(_columnIndexOfPlot)
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpCast: String?
            if (_stmt.isNull(_columnIndexOfCast)) {
              _tmpCast = null
            } else {
              _tmpCast = _stmt.getText(_columnIndexOfCast)
            }
            val _tmpDirector: String?
            if (_stmt.isNull(_columnIndexOfDirector)) {
              _tmpDirector = null
            } else {
              _tmpDirector = _stmt.getText(_columnIndexOfDirector)
            }
            val _tmpGenre: String?
            if (_stmt.isNull(_columnIndexOfGenre)) {
              _tmpGenre = null
            } else {
              _tmpGenre = _stmt.getText(_columnIndexOfGenre)
            }
            val _tmpReleaseDate: String?
            if (_stmt.isNull(_columnIndexOfReleaseDate)) {
              _tmpReleaseDate = null
            } else {
              _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
            }
            val _tmpLastModified: String?
            if (_stmt.isNull(_columnIndexOfLastModified)) {
              _tmpLastModified = null
            } else {
              _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
            }
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            val _tmpBackdropPath: List<String?>?
            val _tmp: String?
            if (_stmt.isNull(_columnIndexOfBackdropPath)) {
              _tmp = null
            } else {
              _tmp = _stmt.getText(_columnIndexOfBackdropPath)
            }
            _tmpBackdropPath = StringListConverter.stringToList(_tmp)
            val _tmpYoutubeTrailer: String?
            if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
              _tmpYoutubeTrailer = null
            } else {
              _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
            }
            val _tmpEpisodeRunTime: String?
            if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
              _tmpEpisodeRunTime = null
            } else {
              _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
            }
            val _tmpCategoryId: Int?
            if (_stmt.isNull(_columnIndexOfCategoryId)) {
              _tmpCategoryId = null
            } else {
              _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            }
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun getRecentlyAddedFlow(limit: Int): Flow<List<SeriesStream>> {
    val _sql: String = """
        |
        |        SELECT * FROM seriesStreamsTable
        |        ORDER BY lastModified DESC
        |        LIMIT ?
        |    
        """.trimMargin()
    return createFlow(__db, false, arrayOf("seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, limit.toLong())
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getRecommendations(categoryId: Int?, limit: Int): PagingSource<Int, SeriesStream> {
    val _sql: String = """
        |
        |        SELECT * FROM seriesStreamsTable
        |        WHERE (? IS NULL OR categoryId = ?)
        |        ORDER BY releaseDate DESC
        |        LIMIT ?
        |    
        """.trimMargin()
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      var _argIndex: Int = 1
      if (categoryId == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindLong(_argIndex, categoryId.toLong())
      }
      _argIndex = 2
      if (categoryId == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindLong(_argIndex, categoryId.toLong())
      }
      _argIndex = 3
      _stmt.bindLong(_argIndex, limit.toLong())
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("seriesStreamsTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<SeriesStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
          val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
          val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
          val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
          val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
          val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
          val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _result: MutableList<SeriesStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: SeriesStream
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpPlot: String?
            if (_stmt.isNull(_columnIndexOfPlot)) {
              _tmpPlot = null
            } else {
              _tmpPlot = _stmt.getText(_columnIndexOfPlot)
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpCast: String?
            if (_stmt.isNull(_columnIndexOfCast)) {
              _tmpCast = null
            } else {
              _tmpCast = _stmt.getText(_columnIndexOfCast)
            }
            val _tmpDirector: String?
            if (_stmt.isNull(_columnIndexOfDirector)) {
              _tmpDirector = null
            } else {
              _tmpDirector = _stmt.getText(_columnIndexOfDirector)
            }
            val _tmpGenre: String?
            if (_stmt.isNull(_columnIndexOfGenre)) {
              _tmpGenre = null
            } else {
              _tmpGenre = _stmt.getText(_columnIndexOfGenre)
            }
            val _tmpReleaseDate: String?
            if (_stmt.isNull(_columnIndexOfReleaseDate)) {
              _tmpReleaseDate = null
            } else {
              _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
            }
            val _tmpLastModified: String?
            if (_stmt.isNull(_columnIndexOfLastModified)) {
              _tmpLastModified = null
            } else {
              _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
            }
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            val _tmpBackdropPath: List<String?>?
            val _tmp: String?
            if (_stmt.isNull(_columnIndexOfBackdropPath)) {
              _tmp = null
            } else {
              _tmp = _stmt.getText(_columnIndexOfBackdropPath)
            }
            _tmpBackdropPath = StringListConverter.stringToList(_tmp)
            val _tmpYoutubeTrailer: String?
            if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
              _tmpYoutubeTrailer = null
            } else {
              _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
            }
            val _tmpEpisodeRunTime: String?
            if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
              _tmpEpisodeRunTime = null
            } else {
              _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
            }
            val _tmpCategoryId: Int?
            if (_stmt.isNull(_columnIndexOfCategoryId)) {
              _tmpCategoryId = null
            } else {
              _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            }
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override suspend fun getFavoriteStreams(): List<SeriesStream> {
    val _sql: String = "SELECT seriesStreamsTable.*, seriesFavoritesTable.sortOrder AS  'num'  FROM seriesStreamsTable INNER JOIN seriesFavoritesTable ON seriesStreamsTable.streamId = seriesFavoritesTable.streamId ORDER BY seriesFavoritesTable.sortOrder ASC"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getFavoriteStreams(limit: Int?): List<SeriesStream> {
    val _sql: String = "SELECT seriesStreamsTable.*, seriesFavoritesTable.sortOrder AS  'num'  FROM seriesStreamsTable INNER JOIN seriesFavoritesTable ON seriesStreamsTable.streamId = seriesFavoritesTable.streamId ORDER BY seriesFavoritesTable.sortOrder ASC LIMIT ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getFavoriteStreamsFlow(limit: Int?): Flow<List<SeriesStream>> {
    val _sql: String = "SELECT seriesStreamsTable.*, seriesFavoritesTable.sortOrder AS  'num'  FROM seriesStreamsTable INNER JOIN seriesFavoritesTable ON seriesStreamsTable.streamId = seriesFavoritesTable.streamId ORDER BY seriesFavoritesTable.sortOrder ASC LIMIT ?"
    return createFlow(__db, false, arrayOf("seriesStreamsTable", "seriesFavoritesTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getPagedFavoriteStreams(): PagingSource<Int, SeriesStream> {
    val _sql: String = "SELECT seriesStreamsTable.*, seriesFavoritesTable.sortOrder AS  'num'  FROM seriesStreamsTable INNER JOIN seriesFavoritesTable ON seriesStreamsTable.streamId = seriesFavoritesTable.streamId ORDER BY seriesFavoritesTable.sortOrder ASC"
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("seriesStreamsTable", "seriesFavoritesTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<SeriesStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
          val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
          val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
          val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
          val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
          val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
          val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _result: MutableList<SeriesStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: SeriesStream
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpPlot: String?
            if (_stmt.isNull(_columnIndexOfPlot)) {
              _tmpPlot = null
            } else {
              _tmpPlot = _stmt.getText(_columnIndexOfPlot)
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpCast: String?
            if (_stmt.isNull(_columnIndexOfCast)) {
              _tmpCast = null
            } else {
              _tmpCast = _stmt.getText(_columnIndexOfCast)
            }
            val _tmpDirector: String?
            if (_stmt.isNull(_columnIndexOfDirector)) {
              _tmpDirector = null
            } else {
              _tmpDirector = _stmt.getText(_columnIndexOfDirector)
            }
            val _tmpGenre: String?
            if (_stmt.isNull(_columnIndexOfGenre)) {
              _tmpGenre = null
            } else {
              _tmpGenre = _stmt.getText(_columnIndexOfGenre)
            }
            val _tmpReleaseDate: String?
            if (_stmt.isNull(_columnIndexOfReleaseDate)) {
              _tmpReleaseDate = null
            } else {
              _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
            }
            val _tmpLastModified: String?
            if (_stmt.isNull(_columnIndexOfLastModified)) {
              _tmpLastModified = null
            } else {
              _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
            }
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            val _tmpBackdropPath: List<String?>?
            val _tmp: String?
            if (_stmt.isNull(_columnIndexOfBackdropPath)) {
              _tmp = null
            } else {
              _tmp = _stmt.getText(_columnIndexOfBackdropPath)
            }
            _tmpBackdropPath = StringListConverter.stringToList(_tmp)
            val _tmpYoutubeTrailer: String?
            if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
              _tmpYoutubeTrailer = null
            } else {
              _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
            }
            val _tmpEpisodeRunTime: String?
            if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
              _tmpEpisodeRunTime = null
            } else {
              _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
            }
            val _tmpCategoryId: Int?
            if (_stmt.isNull(_columnIndexOfCategoryId)) {
              _tmpCategoryId = null
            } else {
              _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            }
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun getPagedWatchedStreams(): PagingSource<Int, SeriesStream> {
    val _sql: String = """
        |
        |    SELECT * 
        |    FROM seriesStreamsTable 
        |    INNER JOIN watchedSeriesStreamsTable 
        |    ON seriesStreamsTable.streamId = watchedSeriesStreamsTable.episodeId
        |    GROUP BY watchedSeriesStreamsTable.episodeId
        |    ORDER BY watchedSeriesStreamsTable.added DESC
        |""".trimMargin()
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("seriesStreamsTable", "watchedSeriesStreamsTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<SeriesStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
          val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
          val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
          val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
          val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
          val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
          val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _result: MutableList<SeriesStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: SeriesStream
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpPlot: String?
            if (_stmt.isNull(_columnIndexOfPlot)) {
              _tmpPlot = null
            } else {
              _tmpPlot = _stmt.getText(_columnIndexOfPlot)
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpCast: String?
            if (_stmt.isNull(_columnIndexOfCast)) {
              _tmpCast = null
            } else {
              _tmpCast = _stmt.getText(_columnIndexOfCast)
            }
            val _tmpDirector: String?
            if (_stmt.isNull(_columnIndexOfDirector)) {
              _tmpDirector = null
            } else {
              _tmpDirector = _stmt.getText(_columnIndexOfDirector)
            }
            val _tmpGenre: String?
            if (_stmt.isNull(_columnIndexOfGenre)) {
              _tmpGenre = null
            } else {
              _tmpGenre = _stmt.getText(_columnIndexOfGenre)
            }
            val _tmpReleaseDate: String?
            if (_stmt.isNull(_columnIndexOfReleaseDate)) {
              _tmpReleaseDate = null
            } else {
              _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
            }
            val _tmpLastModified: String?
            if (_stmt.isNull(_columnIndexOfLastModified)) {
              _tmpLastModified = null
            } else {
              _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
            }
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            val _tmpBackdropPath: List<String?>?
            val _tmp: String?
            if (_stmt.isNull(_columnIndexOfBackdropPath)) {
              _tmp = null
            } else {
              _tmp = _stmt.getText(_columnIndexOfBackdropPath)
            }
            _tmpBackdropPath = StringListConverter.stringToList(_tmp)
            val _tmpYoutubeTrailer: String?
            if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
              _tmpYoutubeTrailer = null
            } else {
              _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
            }
            val _tmpEpisodeRunTime: String?
            if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
              _tmpEpisodeRunTime = null
            } else {
              _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
            }
            val _tmpCategoryId: Int?
            if (_stmt.isNull(_columnIndexOfCategoryId)) {
              _tmpCategoryId = null
            } else {
              _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            }
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun getWatchedStreamsFlow(limit: Int?): Flow<List<SeriesStream>> {
    val _sql: String = "SELECT *  FROM seriesStreamsTable INNER JOIN watchedSeriesStreamsTable ON seriesStreamsTable.streamId = watchedSeriesStreamsTable.streamId LIMIT ?"
    return createFlow(__db, false, arrayOf("seriesStreamsTable", "watchedSeriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getSizeAsFlow(categoryId: Int?): Flow<Long?> {
    val _sql: String = "SELECT COUNT(*) FROM seriesStreamsTable WHERE (? IS NULL OR categoryId = ?)"
    return createFlow(__db, false, arrayOf("seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getStreamById(id: Int?): SeriesStream? {
    val _sql: String = "SELECT * FROM seriesStreamsTable WHERE streamId = ? LIMIT 1"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (id == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, id.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: SeriesStream?
        if (_stmt.step()) {
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _result = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getRecommendationsList(
    categoryId: Int?,
    limit: Int,
    excludeIds: List<Int?>?,
  ): Flow<List<SeriesStream>> {
    val _stringBuilder: StringBuilder = StringBuilder()
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    SELECT * FROM seriesStreamsTable")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    WHERE (")
    _stringBuilder.append("?")
    _stringBuilder.append(" IS NULL OR categoryId = ")
    _stringBuilder.append("?")
    _stringBuilder.append(")")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    AND (")
    val _inputSize: Int = if (excludeIds == null) 1 else excludeIds.size
    appendPlaceholders(_stringBuilder, _inputSize)
    _stringBuilder.append(" IS NULL OR streamId NOT IN (")
    val _inputSize_1: Int = if (excludeIds == null) 1 else excludeIds.size
    appendPlaceholders(_stringBuilder, _inputSize_1)
    _stringBuilder.append("))")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    ORDER BY RANDOM() ")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    LIMIT ")
    _stringBuilder.append("?")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    val _sql: String = _stringBuilder.toString()
    return createFlow(__db, false, arrayOf("seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 3
        if (excludeIds == null) {
          _stmt.bindNull(_argIndex)
        } else {
          for (_item: Int? in excludeIds) {
            if (_item == null) {
              _stmt.bindNull(_argIndex)
            } else {
              _stmt.bindLong(_argIndex, _item.toLong())
            }
            _argIndex++
          }
        }
        _argIndex = 3 + _inputSize
        if (excludeIds == null) {
          _stmt.bindNull(_argIndex)
        } else {
          for (_item_1: Int? in excludeIds) {
            if (_item_1 == null) {
              _stmt.bindNull(_argIndex)
            } else {
              _stmt.bindLong(_argIndex, _item_1.toLong())
            }
            _argIndex++
          }
        }
        _argIndex = 3 + _inputSize + _inputSize
        _stmt.bindLong(_argIndex, limit.toLong())
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item_2: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item_2 = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item_2)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getWatchedStreamsAsIntermediateFlow(): Flow<List<WatchedIntermediateSeriesStream>> {
    val _sql: String = """
        |SELECT 
        |watchedSeriesStreamsTable.streamId AS watched_streamId, 
        |watchedSeriesStreamsTable.episodeId AS watched_episodeId, 
        |watchedSeriesStreamsTable.videoExtension AS watched_videoExtension, 
        |watchedSeriesStreamsTable.added AS watched_added, 
        |watchedSeriesStreamsTable.progress AS watched_progress, 
        |watchedSeriesStreamsTable.totalProgress AS watched_totalProgress, 
        |watchedSeriesStreamsTable.backdrop AS watched_backdrop, 
        |        seriesStreamsTable.*
        |         FROM seriesStreamsTable
        |            INNER JOIN watchedSeriesStreamsTable 
        |            ON seriesStreamsTable.streamId = watchedSeriesStreamsTable.episodeId
        |           GROUP BY watchedSeriesStreamsTable.episodeId ORDER BY watchedSeriesStreamsTable.added DESC           
        |            
        """.trimMargin()
    return createFlow(__db, false, arrayOf("seriesStreamsTable", "watchedSeriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "watched_streamId")
        val _columnIndexOfEpisodeId: Int = getColumnIndexOrThrow(_stmt, "watched_episodeId")
        val _columnIndexOfVideoExtension: Int = getColumnIndexOrThrow(_stmt, "watched_videoExtension")
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "watched_added")
        val _columnIndexOfProgress: Int = getColumnIndexOrThrow(_stmt, "watched_progress")
        val _columnIndexOfTotalProgress: Int = getColumnIndexOrThrow(_stmt, "watched_totalProgress")
        val _columnIndexOfBackdrop: Int = getColumnIndexOrThrow(_stmt, "watched_backdrop")
        val _columnIndexOfStreamId_1: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<WatchedIntermediateSeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: WatchedIntermediateSeriesStream
          val _tmpWatchedBaseStream: WatchedSeriesStreams
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpEpisodeId: Int
          _tmpEpisodeId = _stmt.getLong(_columnIndexOfEpisodeId).toInt()
          val _tmpVideoExtension: String?
          if (_stmt.isNull(_columnIndexOfVideoExtension)) {
            _tmpVideoExtension = null
          } else {
            _tmpVideoExtension = _stmt.getText(_columnIndexOfVideoExtension)
          }
          val _tmpProgress: Long?
          if (_stmt.isNull(_columnIndexOfProgress)) {
            _tmpProgress = null
          } else {
            _tmpProgress = _stmt.getLong(_columnIndexOfProgress)
          }
          val _tmpTotalProgress: Long?
          if (_stmt.isNull(_columnIndexOfTotalProgress)) {
            _tmpTotalProgress = null
          } else {
            _tmpTotalProgress = _stmt.getLong(_columnIndexOfTotalProgress)
          }
          val _tmpBackdrop: String?
          if (_stmt.isNull(_columnIndexOfBackdrop)) {
            _tmpBackdrop = null
          } else {
            _tmpBackdrop = _stmt.getText(_columnIndexOfBackdrop)
          }
          _tmpWatchedBaseStream = WatchedSeriesStreams(_tmpStreamId,_tmpEpisodeId,_tmpProgress,_tmpVideoExtension,_tmpTotalProgress,_tmpBackdrop)
          _tmpWatchedBaseStream.added = _stmt.getLong(_columnIndexOfAdded)
          val _tmpBaseStream: SeriesStream
          val _tmpStreamId_1: Int
          _tmpStreamId_1 = _stmt.getLong(_columnIndexOfStreamId_1).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _tmpBaseStream = SeriesStream(_tmpStreamId_1,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _item = WatchedIntermediateSeriesStream(_tmpBaseStream,_tmpWatchedBaseStream)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getWatchedStreamsAsIntermediate(limit: Int?): List<WatchedIntermediateSeriesStream> {
    val _sql: String = """
        |SELECT 
        |                watchedSeriesStreamsTable.streamId AS watched_streamId, 
        |                watchedSeriesStreamsTable.episodeId AS watched_episodeId, 
        |                watchedSeriesStreamsTable.videoExtension AS watched_videoExtension, 
        |                watchedSeriesStreamsTable.added AS watched_added, 
        |                watchedSeriesStreamsTable.progress AS watched_progress, 
        |                watchedSeriesStreamsTable.totalProgress AS watched_totalProgress, 
        |                watchedSeriesStreamsTable.backdrop AS watched_backdrop, 
        |        seriesStreamsTable.*
        |         FROM seriesStreamsTable
        |            INNER JOIN watchedSeriesStreamsTable 
        |            ON seriesStreamsTable.streamId = watchedSeriesStreamsTable.episodeId
        |           GROUP BY watchedSeriesStreamsTable.episodeId ORDER BY watchedSeriesStreamsTable.added DESC   LIMIT ?            
        |            
        """.trimMargin()
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "watched_streamId")
        val _columnIndexOfEpisodeId: Int = getColumnIndexOrThrow(_stmt, "watched_episodeId")
        val _columnIndexOfVideoExtension: Int = getColumnIndexOrThrow(_stmt, "watched_videoExtension")
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "watched_added")
        val _columnIndexOfProgress: Int = getColumnIndexOrThrow(_stmt, "watched_progress")
        val _columnIndexOfTotalProgress: Int = getColumnIndexOrThrow(_stmt, "watched_totalProgress")
        val _columnIndexOfBackdrop: Int = getColumnIndexOrThrow(_stmt, "watched_backdrop")
        val _columnIndexOfStreamId_1: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<WatchedIntermediateSeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: WatchedIntermediateSeriesStream
          val _tmpWatchedBaseStream: WatchedSeriesStreams
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpEpisodeId: Int
          _tmpEpisodeId = _stmt.getLong(_columnIndexOfEpisodeId).toInt()
          val _tmpVideoExtension: String?
          if (_stmt.isNull(_columnIndexOfVideoExtension)) {
            _tmpVideoExtension = null
          } else {
            _tmpVideoExtension = _stmt.getText(_columnIndexOfVideoExtension)
          }
          val _tmpProgress: Long?
          if (_stmt.isNull(_columnIndexOfProgress)) {
            _tmpProgress = null
          } else {
            _tmpProgress = _stmt.getLong(_columnIndexOfProgress)
          }
          val _tmpTotalProgress: Long?
          if (_stmt.isNull(_columnIndexOfTotalProgress)) {
            _tmpTotalProgress = null
          } else {
            _tmpTotalProgress = _stmt.getLong(_columnIndexOfTotalProgress)
          }
          val _tmpBackdrop: String?
          if (_stmt.isNull(_columnIndexOfBackdrop)) {
            _tmpBackdrop = null
          } else {
            _tmpBackdrop = _stmt.getText(_columnIndexOfBackdrop)
          }
          _tmpWatchedBaseStream = WatchedSeriesStreams(_tmpStreamId,_tmpEpisodeId,_tmpProgress,_tmpVideoExtension,_tmpTotalProgress,_tmpBackdrop)
          _tmpWatchedBaseStream.added = _stmt.getLong(_columnIndexOfAdded)
          val _tmpBaseStream: SeriesStream
          val _tmpStreamId_1: Int
          _tmpStreamId_1 = _stmt.getLong(_columnIndexOfStreamId_1).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _tmpBaseStream = SeriesStream(_tmpStreamId_1,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _item = WatchedIntermediateSeriesStream(_tmpBaseStream,_tmpWatchedBaseStream)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getRecentlyAddedList(limit: Int): List<SeriesStream> {
    val _sql: String = """
        |
        |        SELECT * FROM seriesStreamsTable
        |        ORDER BY lastModified DESC
        |        LIMIT ?
        |    
        """.trimMargin()
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, limit.toLong())
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun all(
    categoryId: Int?,
    nameQuery: String?,
    limit: Int?,
    offset: Int?,
  ): List<SeriesStream> {
    val _sql: String = "SELECT * FROM seriesStreamsTable WHERE (? IS NULL OR categoryId = ?) AND (? IS NULL OR name LIKE '%' || ? || '%')  ORDER BY lastModified DESC LIMIT ? OFFSET ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 3
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 4
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 5
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        _argIndex = 6
        if (offset == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, offset.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfPlot: Int = getColumnIndexOrThrow(_stmt, "plot")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfCast: Int = getColumnIndexOrThrow(_stmt, "cast")
        val _columnIndexOfDirector: Int = getColumnIndexOrThrow(_stmt, "director")
        val _columnIndexOfGenre: Int = getColumnIndexOrThrow(_stmt, "genre")
        val _columnIndexOfReleaseDate: Int = getColumnIndexOrThrow(_stmt, "releaseDate")
        val _columnIndexOfLastModified: Int = getColumnIndexOrThrow(_stmt, "lastModified")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _columnIndexOfBackdropPath: Int = getColumnIndexOrThrow(_stmt, "backdropPath")
        val _columnIndexOfYoutubeTrailer: Int = getColumnIndexOrThrow(_stmt, "youtubeTrailer")
        val _columnIndexOfEpisodeRunTime: Int = getColumnIndexOrThrow(_stmt, "episodeRunTime")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _result: MutableList<SeriesStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: SeriesStream
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpPlot: String?
          if (_stmt.isNull(_columnIndexOfPlot)) {
            _tmpPlot = null
          } else {
            _tmpPlot = _stmt.getText(_columnIndexOfPlot)
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpCast: String?
          if (_stmt.isNull(_columnIndexOfCast)) {
            _tmpCast = null
          } else {
            _tmpCast = _stmt.getText(_columnIndexOfCast)
          }
          val _tmpDirector: String?
          if (_stmt.isNull(_columnIndexOfDirector)) {
            _tmpDirector = null
          } else {
            _tmpDirector = _stmt.getText(_columnIndexOfDirector)
          }
          val _tmpGenre: String?
          if (_stmt.isNull(_columnIndexOfGenre)) {
            _tmpGenre = null
          } else {
            _tmpGenre = _stmt.getText(_columnIndexOfGenre)
          }
          val _tmpReleaseDate: String?
          if (_stmt.isNull(_columnIndexOfReleaseDate)) {
            _tmpReleaseDate = null
          } else {
            _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          }
          val _tmpLastModified: String?
          if (_stmt.isNull(_columnIndexOfLastModified)) {
            _tmpLastModified = null
          } else {
            _tmpLastModified = _stmt.getText(_columnIndexOfLastModified)
          }
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          val _tmpBackdropPath: List<String?>?
          val _tmp: String?
          if (_stmt.isNull(_columnIndexOfBackdropPath)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(_columnIndexOfBackdropPath)
          }
          _tmpBackdropPath = StringListConverter.stringToList(_tmp)
          val _tmpYoutubeTrailer: String?
          if (_stmt.isNull(_columnIndexOfYoutubeTrailer)) {
            _tmpYoutubeTrailer = null
          } else {
            _tmpYoutubeTrailer = _stmt.getText(_columnIndexOfYoutubeTrailer)
          }
          val _tmpEpisodeRunTime: String?
          if (_stmt.isNull(_columnIndexOfEpisodeRunTime)) {
            _tmpEpisodeRunTime = null
          } else {
            _tmpEpisodeRunTime = _stmt.getText(_columnIndexOfEpisodeRunTime)
          }
          val _tmpCategoryId: Int?
          if (_stmt.isNull(_columnIndexOfCategoryId)) {
            _tmpCategoryId = null
          } else {
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          }
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          _item = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun trendingAsFlow(): Flow<List<TrendingTvShow>> {
    val _sql: String = """
        |
        |SELECT 
        |    trending.streamIcon, 
        |    trending.name, 
        |    trending.adult, 
        |    trending.id, 
        |    trending.overview, 
        |    trending.backdrop,
        |    trending.popularity, 
        |    trending.releaseDate, 
        |    trending.voteAverage,
        |    tvShow.streamId
        |FROM TrendingTvShows trending 
        |JOIN seriesStreamsTable tvShow 
        |    ON tvShow.name LIKE trending.name
        |WHERE tvShow.streamIcon IS NOT NULL
        |GROUP BY tvShow.streamId
        |""".trimMargin()
    return createFlow(__db, false, arrayOf("TrendingTvShows", "seriesStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfStreamIcon: Int = 0
        val _columnIndexOfName: Int = 1
        val _columnIndexOfAdult: Int = 2
        val _columnIndexOfId: Int = 3
        val _columnIndexOfOverview: Int = 4
        val _columnIndexOfBackdrop: Int = 5
        val _columnIndexOfPopularity: Int = 6
        val _columnIndexOfReleaseDate: Int = 7
        val _columnIndexOfVoteAverage: Int = 8
        val _columnIndexOfStreamId: Int = 9
        val _result: MutableList<TrendingTvShow> = mutableListOf()
        while (_stmt.step()) {
          val _item: TrendingTvShow
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpAdult: Boolean
          val _tmp: Int
          _tmp = _stmt.getLong(_columnIndexOfAdult).toInt()
          _tmpAdult = _tmp != 0
          val _tmpId: Int
          _tmpId = _stmt.getLong(_columnIndexOfId).toInt()
          val _tmpOverview: String
          _tmpOverview = _stmt.getText(_columnIndexOfOverview)
          val _tmpBackdrop: String?
          if (_stmt.isNull(_columnIndexOfBackdrop)) {
            _tmpBackdrop = null
          } else {
            _tmpBackdrop = _stmt.getText(_columnIndexOfBackdrop)
          }
          val _tmpPopularity: Float?
          if (_stmt.isNull(_columnIndexOfPopularity)) {
            _tmpPopularity = null
          } else {
            _tmpPopularity = _stmt.getDouble(_columnIndexOfPopularity).toFloat()
          }
          val _tmpReleaseDate: String
          _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          val _tmpVoteAverage: Double?
          if (_stmt.isNull(_columnIndexOfVoteAverage)) {
            _tmpVoteAverage = null
          } else {
            _tmpVoteAverage = _stmt.getDouble(_columnIndexOfVoteAverage)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          _item = TrendingTvShow(_tmpAdult,_tmpBackdrop,_tmpId,_tmpName,_tmpOverview,_tmpStreamIcon,_tmpPopularity,_tmpReleaseDate,_tmpVoteAverage,_tmpStreamId)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteAll() {
    val _sql: String = "DELETE FROM seriesStreamsTable"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteTrending() {
    val _sql: String = "DELETE FROM TrendingTvShows"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsPagingSourceRaw(query: RoomRawQuery): PagingSource<Int, SeriesStream> {
    val _sql: String = query.sql
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      query.getBindingFunction().invoke(_stmt)
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("seriesStreamsTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<SeriesStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _result: MutableList<SeriesStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: SeriesStream
            _item = __entityStatementConverter_comXtreamDataKmpDtoSeriesStream(_stmt)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  private fun __entityStatementConverter_comXtreamDataKmpDtoSeriesStream(statement: SQLiteStatement): SeriesStream {
    val _entity: SeriesStream
    val _columnIndexOfStreamId: Int = getColumnIndex(statement, "streamId")
    val _columnIndexOfNum: Int = getColumnIndex(statement, "num")
    val _columnIndexOfName: Int = getColumnIndex(statement, "name")
    val _columnIndexOfPlot: Int = getColumnIndex(statement, "plot")
    val _columnIndexOfStreamIcon: Int = getColumnIndex(statement, "streamIcon")
    val _columnIndexOfCast: Int = getColumnIndex(statement, "cast")
    val _columnIndexOfDirector: Int = getColumnIndex(statement, "director")
    val _columnIndexOfGenre: Int = getColumnIndex(statement, "genre")
    val _columnIndexOfReleaseDate: Int = getColumnIndex(statement, "releaseDate")
    val _columnIndexOfLastModified: Int = getColumnIndex(statement, "lastModified")
    val _columnIndexOfRating: Int = getColumnIndex(statement, "rating")
    val _columnIndexOfRatingFiveBased: Int = getColumnIndex(statement, "ratingFiveBased")
    val _columnIndexOfBackdropPath: Int = getColumnIndex(statement, "backdropPath")
    val _columnIndexOfYoutubeTrailer: Int = getColumnIndex(statement, "youtubeTrailer")
    val _columnIndexOfEpisodeRunTime: Int = getColumnIndex(statement, "episodeRunTime")
    val _columnIndexOfCategoryId: Int = getColumnIndex(statement, "categoryId")
    val _columnIndexOfStreamType: Int = getColumnIndex(statement, "streamType")
    val _tmpStreamId: Int
    if (_columnIndexOfStreamId == -1) {
      _tmpStreamId = 0
    } else {
      _tmpStreamId = statement.getLong(_columnIndexOfStreamId).toInt()
    }
    val _tmpNum: Int?
    if (_columnIndexOfNum == -1) {
      _tmpNum = null
    } else {
      if (statement.isNull(_columnIndexOfNum)) {
        _tmpNum = null
      } else {
        _tmpNum = statement.getLong(_columnIndexOfNum).toInt()
      }
    }
    val _tmpName: String
    if (_columnIndexOfName == -1) {
      error("Missing column 'name' for a NON-NULL value, column not found in result.")
    } else {
      _tmpName = statement.getText(_columnIndexOfName)
    }
    val _tmpPlot: String?
    if (_columnIndexOfPlot == -1) {
      _tmpPlot = null
    } else {
      if (statement.isNull(_columnIndexOfPlot)) {
        _tmpPlot = null
      } else {
        _tmpPlot = statement.getText(_columnIndexOfPlot)
      }
    }
    val _tmpStreamIcon: String?
    if (_columnIndexOfStreamIcon == -1) {
      _tmpStreamIcon = null
    } else {
      if (statement.isNull(_columnIndexOfStreamIcon)) {
        _tmpStreamIcon = null
      } else {
        _tmpStreamIcon = statement.getText(_columnIndexOfStreamIcon)
      }
    }
    val _tmpCast: String?
    if (_columnIndexOfCast == -1) {
      _tmpCast = null
    } else {
      if (statement.isNull(_columnIndexOfCast)) {
        _tmpCast = null
      } else {
        _tmpCast = statement.getText(_columnIndexOfCast)
      }
    }
    val _tmpDirector: String?
    if (_columnIndexOfDirector == -1) {
      _tmpDirector = null
    } else {
      if (statement.isNull(_columnIndexOfDirector)) {
        _tmpDirector = null
      } else {
        _tmpDirector = statement.getText(_columnIndexOfDirector)
      }
    }
    val _tmpGenre: String?
    if (_columnIndexOfGenre == -1) {
      _tmpGenre = null
    } else {
      if (statement.isNull(_columnIndexOfGenre)) {
        _tmpGenre = null
      } else {
        _tmpGenre = statement.getText(_columnIndexOfGenre)
      }
    }
    val _tmpReleaseDate: String?
    if (_columnIndexOfReleaseDate == -1) {
      _tmpReleaseDate = null
    } else {
      if (statement.isNull(_columnIndexOfReleaseDate)) {
        _tmpReleaseDate = null
      } else {
        _tmpReleaseDate = statement.getText(_columnIndexOfReleaseDate)
      }
    }
    val _tmpLastModified: String?
    if (_columnIndexOfLastModified == -1) {
      _tmpLastModified = null
    } else {
      if (statement.isNull(_columnIndexOfLastModified)) {
        _tmpLastModified = null
      } else {
        _tmpLastModified = statement.getText(_columnIndexOfLastModified)
      }
    }
    val _tmpRating: String?
    if (_columnIndexOfRating == -1) {
      _tmpRating = null
    } else {
      if (statement.isNull(_columnIndexOfRating)) {
        _tmpRating = null
      } else {
        _tmpRating = statement.getText(_columnIndexOfRating)
      }
    }
    val _tmpRatingFiveBased: String?
    if (_columnIndexOfRatingFiveBased == -1) {
      _tmpRatingFiveBased = null
    } else {
      if (statement.isNull(_columnIndexOfRatingFiveBased)) {
        _tmpRatingFiveBased = null
      } else {
        _tmpRatingFiveBased = statement.getText(_columnIndexOfRatingFiveBased)
      }
    }
    val _tmpBackdropPath: List<String?>?
    if (_columnIndexOfBackdropPath == -1) {
      _tmpBackdropPath = null
    } else {
      val _tmp: String?
      if (statement.isNull(_columnIndexOfBackdropPath)) {
        _tmp = null
      } else {
        _tmp = statement.getText(_columnIndexOfBackdropPath)
      }
      _tmpBackdropPath = StringListConverter.stringToList(_tmp)
    }
    val _tmpYoutubeTrailer: String?
    if (_columnIndexOfYoutubeTrailer == -1) {
      _tmpYoutubeTrailer = null
    } else {
      if (statement.isNull(_columnIndexOfYoutubeTrailer)) {
        _tmpYoutubeTrailer = null
      } else {
        _tmpYoutubeTrailer = statement.getText(_columnIndexOfYoutubeTrailer)
      }
    }
    val _tmpEpisodeRunTime: String?
    if (_columnIndexOfEpisodeRunTime == -1) {
      _tmpEpisodeRunTime = null
    } else {
      if (statement.isNull(_columnIndexOfEpisodeRunTime)) {
        _tmpEpisodeRunTime = null
      } else {
        _tmpEpisodeRunTime = statement.getText(_columnIndexOfEpisodeRunTime)
      }
    }
    val _tmpCategoryId: Int?
    if (_columnIndexOfCategoryId == -1) {
      _tmpCategoryId = null
    } else {
      if (statement.isNull(_columnIndexOfCategoryId)) {
        _tmpCategoryId = null
      } else {
        _tmpCategoryId = statement.getLong(_columnIndexOfCategoryId).toInt()
      }
    }
    val _tmpStreamType: String
    if (_columnIndexOfStreamType == -1) {
      error("Missing column 'streamType' for a NON-NULL value, column not found in result.")
    } else {
      _tmpStreamType = statement.getText(_columnIndexOfStreamType)
    }
    _entity = SeriesStream(_tmpStreamId,_tmpNum,_tmpName,_tmpPlot,_tmpStreamIcon,_tmpCast,_tmpDirector,_tmpGenre,_tmpReleaseDate,_tmpLastModified,_tmpRating,_tmpRatingFiveBased,_tmpBackdropPath,_tmpYoutubeTrailer,_tmpEpisodeRunTime,_tmpCategoryId,_tmpStreamType)
    return _entity
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
